// import React, { useEffect, useState } from "react";
// import {
//   MdOutlineAccountBalanceWallet,
//   MdOutlineConfirmationNumber,
//   MdOutlineWorkHistory,
// } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import { fetchAdminSponsor } from "../../ApiCalls/AddProducts";

// const AdminSponsor = () => {
//    const [sponsor, setSponsor] = useState([]);
//      const [filter, setFilter] = useState(null);
//      const [loading, setLoading] = useState(true);
//      const navigate = useNavigate();

//      useEffect(() => {
//        const fetchSponsor = async () => {
//         setLoading(true);
//          try {
//            const response = await fetchAdminSponsor(filter);
//            setSponsor(response.Data || []);
//          } catch (error) {
//            console.log(error);
//           } finally {
//             setLoading(false);
//           }
//        };
//        fetchSponsor();
//      }, [filter]);
//   const filters = [
//     {
//       key: 1,
//       label: "All",
//       value: null,
//       icon: <MdOutlineAccountBalanceWallet />,
//     },
//     {
//       key: 2,
//       label: "Approved",
//       value: "approved",
//       icon: <MdOutlineWorkHistory />,
//     },
//     {
//       key: 3,
//       label: "Rejected",
//       value: "rejected",
//       icon: <MdOutlineConfirmationNumber />,
//     },
//     {
//       key: 3,
//       label: "Pending",
//       value: "pending",
//       icon: <MdOutlineConfirmationNumber />,
//     },
//   ];
//   return (
//     <div className="h-full w-full space-y-4 p-5">
//       <div>
//         <div className="flex w-full items-center justify-around border-b bg-white p-2">
//           {filters.map((f) => (
//             <div
//               key={f.key}
//               onClick={() => setFilter(f.value)}
//               className={`flex cursor-pointer items-center gap-1 ${
//                 filter === f.value ? "font-bold text-brand-button-green-bg" : ""
//               }`}
//             >
//               {f.icon}
//               {f.label}
//             </div>
//           ))}
//         </div>
//         {fetchedOrders?.length > 0 ? (
//         <div className="flex w-full flex-col">
//           {/* Header */}
//           <div className="w-full">
//             <div className="grid w-full grid-cols-[4rem,2fr,2.5fr,2fr,2fr,2fr,2.5fr,1.5fr] bg-white p-2 font-medium text-brand-button-green-bg">
//               <div className="text-center">No</div>
//               <div className="text-center">Order Date</div>
//               <div className="text-center">Order No</div>
//               <div className="text-center">Place</div>
//               <div className="text-center">Total Amount</div>
//               <div className="text-center">Seller Comment</div>
//               <div className="text-center">Status</div>
//               <div className="text-center">Actions</div>
//             </div>
//           </div>
//           <div className="mt-10">
//             {/* Order Rows */}
//             {fetchedOrders.map((order, index) => (
//               <div
//                 key={order.id}
//                 className="grid grid-cols-[4rem,2fr,2.5fr,2fr,2fr,2fr,2.5fr,1.5fr] items-center gap-2 p-2"
//               >
//                 <div className="rounded border p-2 text-center">
//                   {index + 1}
//                 </div>
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   {order.order_date}
//                 </div>
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   {order.order_number}
//                 </div>
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   {order.place}
//                 </div>
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   ₹ {order.total_amount}
//                 </div>
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   {order.seller_comment || "No comment"}
//                 </div>
//                 <div className="rounded border p-2 text-center">
//                   {order.order_status || "Unknown Status"}
//                 </div>
//                 <div className="flex justify-center gap-2">
//                   <button
//                     onClick={() =>
//                       navigate(
//                         `/admin/orders/view_order/${order.order_number}`,
//                       )
//                     }
//                     className="rounded-md bg-brand-button-green-bg p-2 px-4 text-white"
//                   >
//                     View
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       ) : (
//         <div className="flex h-[90%] w-full flex-col items-center justify-center">
//           <img
//             src={NoOrders}
//             alt="No orders found"
//             className="h-auto w-52 object-cover"
//           />
//           <h2 className="mt-2 text-2xl font-medium">No orders found</h2>
//         </div>
//       )}
//       </div>

//     </div>
//   );
// };

// export default AdminSponsor;

import React, { useEffect, useState } from "react";
import {
  MdOutlineAccountBalanceWallet,
  MdOutlineConfirmationNumber,
  MdOutlineWorkHistory,
} from "react-icons/md";
import { BsBoxSeam } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { fetchAdminSponsor } from "../../ApiCalls/AddProducts";
import ConfirmationModal from "../AdminApproval/ConfirmationModal";
import { USER_URL } from "../../constant/api";

const AdminSponsor = () => {
  const [sponsor, setSponsor] = useState([]);
  const [filter, setFilter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [actionType, setActionType] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSponsor = async () => {
      setLoading(true);
      try {
        const response = await fetchAdminSponsor(filter);
        setSponsor(response?.Data || []);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchSponsor();
  }, [filter]);

  const filters = [
    {
      key: 1,
      label: "All",
      value: null,
      icon: <MdOutlineAccountBalanceWallet />,
    },
    {
      key: 2,
      label: "Approved",
      value: "approved",
      icon: <MdOutlineWorkHistory />,
    },
    {
      key: 3,
      label: "Rejected",
      value: "rejected",
      icon: <MdOutlineConfirmationNumber />,
    },
    {
      key: 4,
      label: "Pending",
      value: "pending",
      icon: <MdOutlineConfirmationNumber />,
    }, // Unique key
  ];
  const openModal = (product, action) => {
    setSelectedSponsor(product);
    setActionType(action);
    setModalOpen(true);
  };

  // Handle seller status update
  const handleConfirm = async () => {
    if (selectedSponsor && selectedSponsor.id) {
      try {
        const newStatus = actionType === "Approve" ? "Approved" : "Rejected";
        await USER_URL.post(`products/admin/sponsored/${selectedSponsor.id}/`, {
          status: newStatus,
        });
        // Update UI
        setSponsor((prevSponsor) =>
          prevSponsor.map((product) =>
            product.id === selectedSponsor.id
              ? { ...product, status: newStatus }
              : product,
          ),
        );
      } catch (error) {
        console.error("Error updating status:", error.message || error);
      } finally {
        setModalOpen(false);
      }
    } else {
      console.error("Invalid product ID:", selectedSponsor);
    }
  };
  return (
    <div className="h-full w-full space-y-4 p-5">
      <h1 className="text-cen text-2xl font-medium text-green-600">
        Admin Sponsor Approval
      </h1>
      <div>
        {/* Filter Buttons */}
        <div className="flex w-full items-center justify-around border-b bg-white p-2">
          {filters.map((f) => (
            <div
              key={f.key}
              onClick={() => setFilter(f.value)}
              className={`flex cursor-pointer items-center gap-1 ${
                filter === f.value ? "font-bold text-brand-button-green-bg" : ""
              }`}
            >
              {f.icon}
              {f.label}
            </div>
          ))}
        </div>

        {loading ? (
          <div className="flex h-40 items-center justify-center">
            <div className="spinner-border inline-block h-8 w-8 animate-spin rounded-full border-4 text-brand-primary"></div>
            <p className="ml-2">Loading Sponsor...</p>
          </div>
        ) : sponsor.length === 0 ? (
          <div className="mt-10 text-center">
            <BsBoxSeam className="mx-auto mb-4 text-6xl text-gray-400" />
            <p className="text-lg text-gray-600">
              No sponsored products available
            </p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            {/* Table Header */}
            <div className="mt-10 w-full space-y-4">
              <div className="grid min-w-[800px] grid-cols-[4rem,2fr,2fr,2fr,1fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
                <div className="text-center">Item No</div>
                {/* <div className="text-center">Seller Name</div> */}
                <div className="text-center">Banner Name</div>
                <div className="text-center">Start Date</div>
                <div className="text-center">End Date</div>
                <div className="text-center">Status</div>
                <div className="text-center"></div>
                <div className="text-center"></div>
              </div>
            </div>

            {/* Table Body */}
            {sponsor.map((s, index) => (
              <div
                key={s.id}
                className="grid min-w-[800px] grid-cols-[4rem,2fr,2fr,2fr,1fr,1fr,1fr,1fr] items-center gap-2 py-2 text-[#2F2E41]"
              >
                <div className="rounded-xl border p-2 text-center">
                  {index + 1}
                </div>
                <div className="rounded-xl border p-2 text-center">
                  {s.title}
                </div>
                <div className="rounded-xl border p-2 text-center">
                  {new Date(s.start_date).toLocaleDateString("en-GB")}
                </div>
                <div className="rounded-xl border p-2 text-center">
                  {new Date(s.end_date).toLocaleDateString("en-GB")}
                </div>
                <div  className={`rounded-lg border px-4 py-2 text-sm ${
                        s.status === "Approved"
                          ? "text-green-600 border-green-600"
                          : s.status === "Rejected"
                          ? "text-red-600 border-red-600"
                          : "text-yellow-600 border-yellow-600"
                      }`}>
                  {s.status}
                </div>

                <button
                  onClick={() =>
                    openModal(s, s.status === "Approved" ? "Reject" : "Approve")
                  }
                  className={`${
                    s.status === "Approved"
                      ? "border-red-600 text-red-600 hover:bg-red-100"
                      : "border-green-600 text-green-600 hover:bg-green-100"
                  } w-[100px] rounded-lg border px-4 py-2 text-sm font-medium`}
                >
                  {s.status === "Approved" ? "Reject" : "Approve"}
                </button>
                <Link to={`/admin/approval/sponsor/view/${s.id}`}>
                  <div className="flex flex-1 cursor-pointer items-center justify-center rounded-lg border border-green-600 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm">
                    View
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
        action={actionType}
        product={selectedSponsor}
      />
    </div>
  );
};

export default AdminSponsor;
